module.exports = __webpack_public_path__ + "img/IMG_5615_P-2_L_WoodMatted_MockedUp.6bc93fb8.jpg";